/**
 * @file: SystemAlertBody.tsx
 *
 * `OrgSystemAlert` — platform-level alert. Title color carries the
 * severity (info / warning / error).
 */

import { OrgSystemAlertFeedPayload } from '@euler/model/feed';
import { FC } from 'react';
import { View } from 'react-native';
import { BodyText, TitleText } from './common/primitives';

export const SystemAlertBody: FC<{ p: OrgSystemAlertFeedPayload }> = ({
  p,
}) => {
  const color =
    p.severity === 'error'
      ? '#ff3b30'
      : p.severity === 'warning'
      ? '#ff9500'
      : '#1f80ff';
  return (
    <View>
      <TitleText color={color}>{p.title}</TitleText>
      <BodyText mt={6}>{p.message}</BodyText>
    </View>
  );
};
